import { Box } from "@mui/material";
import Button from "components/common/Button";
//import { ReactComponent as PinIcon } from "assets/PinIcon.svg";
import ThemeContext from "components/app/Context";
import DialogFormation from "components/common/DialogFormation";
import { updateCorpSavedFilters } from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { resetPageModifiedFilter, setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Input from "components/common/Input";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { resetSorting } from "redux/sorting.slice";
import { setCorpSearchText, setDialog, setSelectedList, setSelectedListCategory } from "../../Corp/CorpUser.Slice";
import "../MyLists.scss";

export default function RenameList() {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { isMobileScreen } = useContext(ThemeContext);
  const { isOpen, data } = useAppSelector((state) => state.CorpDashboard.dialogs.renameList);
  const selectedList = useAppSelector((state) => state.CorpDashboard.myListsSelected.selectedList);

  const [listName, setListName] = useState<string>("");

  useEffect(() => {
    if (Object.keys(data)?.length) setListName(data?.name);
  }, [data]);

  const handleClose = () => {
    dispatch(setDialog({ dialogName: "renameList", isOpen: false, data: {} }));
  };

  const onRenameClick = async () => {
    const props = {
      dynamic: [{ ...data, name: listName }]
    };
    const res: any = await dispatch(updateCorpSavedFilters(props));
    if (res?.meta?.requestStatus === "fulfilled") {
      handleClose();
      dispatch(setSelectedList({ ...data, name: listName }));
      dispatch(setSelectedListCategory("dynamic"));
      dispatch(
        resetPageModifiedFilter({
          pageName: [filterPage.consultantListDisplay]
        })
      );
      dispatch(setPageFilter({ pageName: filterPage.listDisplay, defaultFilter: data.filters }));
      dispatch(
        resetSorting({
          tableName: "plansSort_myList"
        })
      );
      dispatch(
        resetSorting({
          tableName: "propertiesSort_myList"
        })
      );
      dispatch(setCorpSearchText({ view: "myList", value: "" }));

      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "success",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("common.renameList")
        })
      );
    }
  };

  return (
    <>
      {isOpen && (
        <DialogFormation
          title="Rename list"
          openDialog={isOpen}
          handleClose={handleClose}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleClose} width={isMobileScreen ? "50%" : "25%"} />
              <Button
                disabled={listName && listName !== data?.name ? false : true}
                variant="primary"
                label="Apply Changes"
                onClick={onRenameClick}
                width={isMobileScreen ? "50%" : "25%"}
              />
            </div>
          }
        >
          <Box paddingX={"15px"} paddingY={"10px"}>
            <Input
              onChange={(event: any) => setListName(event.target.value)}
              name="ListName"
              textVariant="body2"
              label={"Rename your list"}
              value={data?.name}
            />
          </Box>
        </DialogFormation>
      )}
    </>
  );
}
